var zhCn = {
  name: "zh-cn",
  plus: {
    dialog: {
      confirmText: "\u786E\u5B9A",
      cancelText: "\u53D6\u6D88",
      title: "\u5F39\u7A97"
    },
    datepicker: {
      startPlaceholder: "\u8BF7\u9009\u62E9\u5F00\u59CB\u65F6\u95F4",
      endPlaceholder: "\u8BF7\u9009\u62E9\u7ED3\u675F\u65F6\u95F4"
    },
    dialogForm: {
      title: "\u5F39\u7A97\u8868\u5355"
    },
    drawerForm: {
      title: "\u62BD\u5C49\u8868\u5355",
      confirmText: "\u786E\u5B9A",
      cancelText: "\u53D6\u6D88"
    },
    form: {
      submitText: "\u63D0\u4EA4",
      resetText: "\u91CD\u7F6E",
      errorTip: "\u8BF7\u5B8C\u6574\u586B\u5199\u8868\u5355\u7136\u540E\u518D\u6B21\u63D0\u4EA4\uFF01"
    },
    field: {
      pleaseEnter: "\u8BF7\u8F93\u5165",
      pleaseSelect: "\u8BF7\u9009\u62E9"
    },
    popover: {
      confirmText: "\u786E\u5B9A",
      cancelText: "\u53D6\u6D88"
    },
    search: {
      searchText: "\u641C\u7D22",
      resetText: "\u91CD\u7F6E",
      expand: "\u5C55\u5F00",
      retract: "\u6536\u8D77"
    },
    table: {
      title: "\u8868\u683C",
      density: "\u5BC6\u5EA6",
      refresh: "\u5237\u65B0",
      columnSettings: "\u5217\u8BBE\u7F6E",
      selectAll: "\u5168\u9009",
      default: "\u9ED8\u8BA4",
      loose: "\u5BBD\u677E",
      compact: "\u7D27\u51D1",
      action: "\u64CD\u4F5C",
      more: "\u66F4\u591A",
      confirmToPerformThisOperation: "\u786E\u5B9A\u6267\u884C\u672C\u6B21\u64CD\u4F5C?",
      prompt: "\u63D0\u793A",
      sort: "\u6392\u5E8F",
      resetText: "\u91CD\u7F6E"
    },
    stepsForm: {
      nextText: "\u4E0B\u4E00\u6B65",
      preText: "\u4E0A\u4E00\u6B65",
      submitText: "\u63D0\u4EA4"
    },
    inputTag: {
      placeholder: "\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u540E\u6309\u56DE\u8F66/\u7A7A\u683C\u952E"
    },
    header: {
      logout: "\u9000\u51FA\u767B\u5F55"
    }
  }
};

export { zhCn as default };
